<template>
  <div class="page_container">
    <div class="title">
      <!-- <h1 class="mt20" style="font-weight:500">Custom Neon Online</h1> -->
      <span
        >Choose the template to design or<a @click="go2editor" href="javascript:void(0)"> Do My Own Design</a>
      </span>
    </div>
    <el-row class="flex flex-start flex-wrap list_container" v-loading="listLoading">
      <div v-if="data.rows.length == 0">No data yet.</div>
      <template v-for="item in data.rows">
        <div class="asset_item" :key="item.id">
          <div class="card custom_pro_card" @click="handleItemClick(item.id)">
            <img :src="item.preview" alt />
          </div>
          <div class="product_title">{{ item.name }}</div>
        </div>
      </template>
    </el-row>
    <!-- <PageNavigation start="1"></PageNavigation> -->
    <el-pagination
      class="mt20"
      background
      layout="prev, pager, next"
      :page-size="pagination.limit"
      :total="data.count"
      @current-change="pageChange"
    ></el-pagination>

    <div class="font_load_container">
      <div v-for="item in fontList" :key="item" :style="'font-family:' + item">.</div>
    </div>
  </div>
</template>

<script>
import PageNavigation from '@/components/PageNavigation.vue';
export default {
  components: {
    PageNavigation,
  },
  data() {
    return {
      keyword: '',
      catgory: '',
      isShowUploader: false,
      data: {
        rows: [],
      },
      pagination: {
        current: 0,
        limit: 12,
      },
      catgoryList: [],
      listLoading: false,
      fontList: [
        'Aoox',
        'Autoguard',
        'BadScript',
        'BaristaScript',
        'Bath',
        'BEYNO',
        'BreakFill',
        'BukhariScript',
        'Dobby',
        'Fitalia',
        'Garden',
        'LondrinaOutline',
        'LoveloLine',
        'Marske',
        'Megrim',
        'Neoneon',
        'Paralines',
        'PoiretOne',
        'Prince',
        // 'SEGOESC',
        'Snow',
        'Waxe',
      ],
    };
  },
  mounted() {
    // console.log(this.$http);
    // this.$axios.get("/");
    this.getList();
    this.getCatgory();
  },
  methods: {
    async getList() {
      const offset = this.pagination.current * this.pagination.limit;
      this.listLoading = true;
      const res = await this.$axios.get(
        `/custom/list?offset=${offset}&limit=${this.pagination.limit}&keyword=${this.keyword}&catgory=${this.catgory}`
      );
      this.listLoading = false;
      this.data = res.data;
    },
    pageChange(e) {
      this.pagination.current = e - 1;
      this.getList();
    },
    async getCatgory() {
      const res = await this.$axios.get('/catgory');
      if (res.data.code == 1) {
        // console.log(res.data);
        this.catgoryList = res.data.data.rows;
      }
    },
    handleItemClick(id) {
      this.$router.push({
        path: `/product/${id}`,
      });
    },

    go2editor() {
      this.$router.push({
        path: `/product/new`,
      });
    },
  },
};
</script>

<style lang="less">
.font_load_container {
  opacity: 0;
  height: 0;
  width: 0;
}
.custom_pro_card {
  width: 100%;
  // height: 230px;
  // margin: 10px 20px 5px 0;
  overflow: hidden;
  background: #000;
  border-radius: 0;
  margin: 0 auto;
  // padding: 10px;
  box-sizing: border-box;
  img {
    display: block;
    width: 100%;
  }
}

.list_container {
  // border-top: 1px solid #e1e3e4;
  // border-left: 1px solid #e1e3e4;
  // background: #e1e3e4;
  display: flex;
  justify-content: flex-start;
  width: auto;
  min-width: 320px;
}

.asset_item {
  width: 24.8%;
  padding: 20px;
  min-width: 200px;
  min-height: 300px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  font-size: 16px;
  // margin-bottom: 20px;
  // border-bottom: 1px solid #e1e3e4;
  // border-right: 1px solid #e1e3e4;
  border: 1px solid #e1e3e4;
  background: #fff;
  // margin-left: 0.1%;
  margin-top: -1px;
  margin-right: -1px;
  img {
    display: block;
    background: #000;
    min-height: 236px;
  }
  .product_title {
    font-size: 16px;
    font-family: Akko, sans-serif;
    font-weight: 600;
    margin-top: 20px;
    display: block;
    margin-bottom: 20px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .delete_icon {
    position: absolute;
    right: 30px;
    top: 30px;
    display: none;
  }
  &:hover {
    opacity: 0.9;
    .product_title {
      color: #b963fd;
    }
  }
}

@media screen and (min-width: 1100px) {
  .asset_item {
    min-width: 200px;
    img {
      min-height: auto;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1099px) {
  .asset_item {
    min-width: 200px;
    img {
      min-height: auto;
    }
  }
}

@media screen and (max-width: 768px) {
  .page_container {
    padding: 0;
  }
  .asset_item {
    min-width: 50%;
    padding: 0;
    min-height: auto;
    img {
      min-height: auto;
    }
  }
}

.asset_item:hover {
  .delete_icon {
    display: block;
    cursor: pointer;
  }
}

.title {
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  h1 {
    margin: 20px 0;
    font-size: 30px;
  }
  span {
    font-size: 20px;
    padding: 5px 0;
    display: inline-block;
    color: #333;
    font-weight: 300;
    a {
      display: inline-block;
      // width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      text-decoration: none;
      background: #b963fd;
      padding: 0 20px;
      margin-left: 20px;
      border-radius: 3px;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
